/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {EmGroup} from './em-group';
import {Image} from './image';
import {InstanceData} from './instance-data';

export abstract class BaseInstance {
  id: number;
  name: string;
  description: string;
  image: Image;
  icon: Image;
  uuid: string;
  
  data: InstanceData[];
  groups: EmGroup[];
}
